/**
 * Twin of `coa_subtype_normal_balance(subtype)`: a contra subtype's own side,
 * else the category's.
 */
export function subtypeRuleSide(subtypeSide, categorySide) {
    return subtypeSide ?? categorySide ?? undefined;
}
/**
 * Twin of the sub-account side rule (trg_assign_account_number,
 * update_account_classification, coa_template_account_derive_hierarchy —
 * SQL twin 20261006220000): a sub-account on a CONTRA subtype of its parent's
 * type takes that subtype's side; any other sub-account its parent's.
 */
export function childRuleSide(ownSubtypeSide, parentSide) {
    return ownSubtypeSide ?? parentSide ?? undefined;
}
/**
 * Twin of `coa_child_subtype_ok` plus the parent's own subtype: the subtypes a
 * sub-account may carry — its parent's, or a CONTRA subtype (one with its own
 * normal balance) of the parent's type. The child-subtype pickers filter on it.
 */
export function isChildSubtypeAllowed(subtype, parent) {
    if (subtype.id === parent.subtype_id)
        return true;
    return subtype.type_id === parent.type_id && !!subtype.normal_balance;
}
/**
 * Twin of the per-row decision in `update_account_classification`, for a row
 * whose classification changed: the rule side, unless the stored side is a
 * manual override (≠ the rule under the OLD classification) that the new rule
 * would change — then the user must choose (`'choose'`). A contra target
 * subtype always takes its own side.
 */
export function resolveReclassifiedSide(args) {
    const { stored, oldRule, newRule, newIsContra } = args;
    if (newIsContra || stored === oldRule || stored === newRule)
        return newRule;
    return "choose";
}
/** The side a conflict ends on for a given answer. */
export const sideForChoice = (conflict, choice) => (choice === "keep" ? conflict.current : conflict.standard);
//# sourceMappingURL=normalBalance.js.map